export default __webpack_public_path__ + "static/media/realtyCase.e68d3f56.jpg";